import { secondAxios } from "../../../../../api/axios";

export async function fetchAllRevsForProject(projectId) {
  const res = await secondAxios.get(`/project/${projectId}/rev`);
  return res.data;
}

export async function fetchStructuralRev(projectId, revId) {
  const res = await secondAxios.get(`/project/${projectId}/rev/${revId}`);
  // console.log("rev res:", res.data);
  return res.data;
}

export async function postStructuralRev(projectId, data) {
  const res = await secondAxios.post(`/project/${projectId}/rev`, data);
  return res.data;
}
export async function updateStructuralRev(projectId, revId, data) {
  console.log("Updating structural revision with data:", data);
  const res = await secondAxios.patch(
    `/project/${projectId}/rev/${revId}`,
    data,
  );
  return res.data;
}

export async function getProjectById(projectId) {
  const response = await secondAxios.get(
    `/project/${projectId}?revisions=true&users=true`,
  );
  console.log("response", { response });
  if (typeof response.data?.data === "string") {
    return JSON.parse(response.data?.data);
  }
  return response?.data;
}

export async function getStructuralPlantProjects(plantId, clientName) {
  const res = await secondAxios.get(
    `project/plant/${plantId}/${clientName}?type=struc`,
  );
  return res.data;
}

export async function getPlantById(plantId) {
  const res = await secondAxios.get(`/plant/${plantId}`);
  return res.data;
}

